module.exports = __webpack_public_path__ + "img/Speaker=Jenny Sun.c23543a9.png";